

















































import { Component, Prop, Vue } from "vue-property-decorator";
import { GapLogType } from "@/store/modules/enums";
import { GapLogEntry } from "@/store/modules/types";

@Component
export default class NotifGapSMS extends Vue {
  @Prop(String) readonly publicId!: string;
  smsConfig: any = null;
  comment = "";
  async getSMSConfig() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch(
        "notifs/getGapSMS",
        this.publicId
      );
      data.WEB_OPTIONS = data.WEB_OPTIONS.map(option => {
        option.selected = false;
        return option;
      });
      this.smsConfig = data;
      this.sendAck();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async sendAck() {
    try {
      const entry: GapLogEntry = {
        gapId: this.smsConfig.GAP_ID,
        typeId: GapLogType.PATIENT_ACKNOWLEDGED_SMS_NOTIFICATION
      };
      await this.$store.dispatch("gaps/saveSystemLog", entry);
    } catch (error) {
      console.log(error);
    }
  }
  async sendComment() {
    if (!this.comment) {
      return;
    }
    this.$store.commit("main/SET_LOADING", true);
    try {
      const entry: GapLogEntry = {
        gapId: this.smsConfig.GAP_ID,
        typeId: GapLogType.PATIENT_COMMENT,
        comment: this.comment
      };
      await this.$store.dispatch("gaps/saveSystemLog", entry);
      this.comment = "";
      this.$modal.show("dialog", {
        title: "PatientCare",
        text: "Thank you! We have received your <b>comment</b>."
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async respond(option) {
    if (option.selected) {
      return;
    }
    for (const option of this.smsConfig.WEB_OPTIONS) {
      option.selected = false;
    }
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("notifs/saveGapSMSResponse", {
        publicId: this.publicId,
        text: option.VALUE
      });
      option.selected = true;
      this.$modal.show("dialog", {
        title: "PatientCare",
        text: "Thank you! We have received your <b>answer</b>."
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  mounted() {
    this.getSMSConfig();
  }
}
